import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Helmet } from '@dr.pogodin/react-helmet';

const ChatBot = ({ fields }) => {
  // Fields
  const pageType = getFieldValue(fields, 'pageType');
  const state = getFieldValue(fields, 'state');
  const areaName = getFieldValue(fields, 'areaName');
  const communityNumber = getFieldValue(fields, 'communityNumber');
  const communityName = getFieldValue(fields, 'communityName');
  const planNumber = getFieldValue(fields, 'planNumber');
  const planName = getFieldValue(fields, 'planName');

  // Always push, never reassign. Reassigning `dataLayer = [...]` after GTM has
  // initialised leaves GTM listening on the old array, so every later
  // window.dataLayer.push() in the app is silently lost (SPA navigation case).
  return (
    <Helmet>
      <script>{`
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "atlasSettings": {
            "pageType": "${pageType}",
            "state": "${state}",
            "areaName": "${areaName}",
            "communityNumber": "${communityNumber}",
            "communityName": "${communityName}",
            "planNumber": "${planNumber}",
            "planName": "${planName}"
          }
        });
      `}</script>
    </Helmet>
  );
};

export default ChatBot;
